import {
  CREATE_SELLER_REPLACEMENT,
  CREATE_SELLER_REPLACEMENT_SUCCESS,
  CREATE_SELLER_REPLACEMENT_ERROR,
  UPDATE_SELLER_REPLACEMENT,
  UPDATE_SELLER_REPLACEMENT_SUCCESS,
  UPDATE_SELLER_REPLACEMENT_ERROR,
  SEARCH_SELLER_REPLACEMENTS,
  SEARCH_SELLER_REPLACEMENTS_SUCCESS,
  SEARCH_SELLER_REPLACEMENTS_ERROR,
  GET_ACTIVE_REPLACEMENT,
  GET_ACTIVE_REPLACEMENT_SUCCESS,
  GET_ACTIVE_REPLACEMENT_ERROR,
  CLEAR_SELLER_REPLACEMENTS_STATE,
} from '../constants/ActionsTypes'

const initialState = {
  replacements: [],
  metadata: null,
  searchRequest: null,
  activeReplacement: null,
  isCreating: false,
  isUpdating: false,
  createSuccess: false,
  updateSuccess: false,
  error: null,
}

function rootReducer(state = initialState, action) {
  switch (action.type) {
    case SEARCH_SELLER_REPLACEMENTS:
      return {
        ...state,
        searchRequest: action.payload,
        error: null,
      }
    case SEARCH_SELLER_REPLACEMENTS_SUCCESS:
      return {
        ...state,
        replacements: action.payload?.data || [],
        metadata: action.payload?.metadata || null,
        error: null,
      }
    case SEARCH_SELLER_REPLACEMENTS_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    case CREATE_SELLER_REPLACEMENT:
      return {
        ...state,
        isCreating: true,
        createSuccess: false,
        error: null,
      }
    case CREATE_SELLER_REPLACEMENT_SUCCESS:
      return {
        ...state,
        isCreating: false,
        createSuccess: true,
        error: null,
      }
    case CREATE_SELLER_REPLACEMENT_ERROR:
      return {
        ...state,
        isCreating: false,
        createSuccess: false,
        error: action.payload,
      }

    case UPDATE_SELLER_REPLACEMENT:
      return {
        ...state,
        isUpdating: true,
        updateSuccess: false,
        error: null,
      }
    case UPDATE_SELLER_REPLACEMENT_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        updateSuccess: true,
        error: null,
      }
    case UPDATE_SELLER_REPLACEMENT_ERROR:
      return {
        ...state,
        isUpdating: false,
        updateSuccess: false,
        error: action.payload,
      }

    case GET_ACTIVE_REPLACEMENT:
      return {
        ...state,
        activeReplacement: null,
        error: null,
      }
    case GET_ACTIVE_REPLACEMENT_SUCCESS:
      return {
        ...state,
        activeReplacement: action.payload.data,
        error: null,
      }
    case GET_ACTIVE_REPLACEMENT_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    case CLEAR_SELLER_REPLACEMENTS_STATE:
      return initialState

    default:
      return state
  }
}

export default rootReducer
